import { render } from "./ReportsPageActions.vue?vue&type=template&id=5d5753a0&ts=true"
import script from "./ReportsPageActions.vue?vue&type=script&lang=ts"
export * from "./ReportsPageActions.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__